<app-header></app-header>
<section id="casos-exito-int" class="bg-grey reset-section-pad2">

    <div class="container" data-aos="fade-right" data-aos-duration="1500">

          <div class="row" >
            <app-title-section
            [titleTxt]="caso.title!"
            >      
            </app-title-section>   
         </div>

           <div class="row equipo-int-blq">

              <div class="col-lg-12 equipo-int-blq-inner-img">
                    <img class="img-fluid" [src]="imgMain" alt="{{caso.imgAlt}}">
                    <div class="int-showcase__footer bg-grey"></div>
               </div>   
        
              <div class="col-lg-8 mt-5 equipo-int-blq-inner-text">                   
                   <p [innerHTML]="caso.mainText"></p>
               </div> 

         </div>

         <div class="row">

            <div class="col-lg-12 col-md-12 col-sm-12 col-12 prev-next">

                <div class="prev-next-blq">
                    <!--activar clase inactiv cuando no haya ningún elemento más adelante o detrás-->
                     <a 
                     [ngClass]="{'inactiv': !id_prev}"
                     [routerLink]="id_prev ? ['/casos-exito/', id_prev] : null"
                     ><span>Anterior</span>
                     </a>
                     <a
                     [ngClass]="{'inactiv': !id_next}"
                     [routerLink]="id_next ? ['/casos-exito/', id_next]: null"
                     ><span>Siguiente</span></a>
     
                </div> 

            </div>

         </div>



     </div><!-- fin container-->

</section>

<app-footer-main>